import { useState } from "react";
import { Check, ChevronDown, ChevronUp } from "lucide-react";

// Nov 2026 · Any 3 Areas $99 — optional area picker (never blocks booking).
export const ANY3_AREAS = [
  "Upper Lip", "Chin", "Sideburns", "Neck", "Underarms", "Bikini Line", "Brazilian",
  "Abdomen", "Lower Back", "Full Arms", "Half Arms", "Hands", "Lower Legs", "Full Legs", "Feet", "Chest", "Back", "Shoulders",
];
const AREAS_FR = {
  "Upper Lip": "Lèvre supérieure", "Chin": "Menton", "Sideburns": "Favoris", "Neck": "Cou", "Underarms": "Aisselles",
  "Bikini Line": "Ligne du bikini", "Brazilian": "Brésilien", "Abdomen": "Abdomen", "Lower Back": "Bas du dos", "Full Arms": "Bras complets",
  "Half Arms": "Demi-bras", "Hands": "Mains", "Lower Legs": "Demi-jambes", "Full Legs": "Jambes complètes", "Feet": "Pieds",
  "Chest": "Poitrine", "Back": "Dos", "Shoulders": "Épaules",
};
export const ANY3_COMBOS = [
  ["Upper Lip", "Chin", "Underarms"],
  ["Brazilian", "Underarms", "Bikini Line"],
  ["Full Legs", "Underarms", "Upper Lip"],
  ["Full Arms", "Underarms", "Chin"],
  ["Bikini Line", "Abdomen", "Underarms"],
];

export default function Any3AreasPicker({ value = [], onChange, isFr }) {
  const [open, setOpen] = useState(false);
  const label = (a) => (isFr ? AREAS_FR[a] || a : a);
  const toggle = (a) => {
    if (value.includes(a)) return onChange(value.filter((x) => x !== a));
    if (value.length >= 3) return;
    onChange([...value, a]);
  };
  const sameCombo = (c) => c.length === value.length && c.every((a) => value.includes(a));

  return (
    <div className="mb-3 rounded-xl border border-emerald-400/40 bg-emerald-500/10 p-3 sm:p-4" data-testid="any3-areas-picker">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 text-left" data-testid="any3-areas-toggle">
        <div>
          <p className="text-emerald-200 text-xs font-bold uppercase tracking-wider">{isFr ? "Optionnel · dites vos 3 zones à Tanya" : "Optional · tell Tanya your 3 areas"}</p>
          <p className="text-zinc-300 text-xs mt-0.5" data-testid="any3-areas-summary">
            {value.length
              ? `${value.map(label).join(" + ")}${value.length < 3 ? ` · ${3 - value.length} ${isFr ? "de plus" : "more"}` : ""}`
              : (isFr ? "Vous pouvez aussi choisir à l'arrivée — la réservation ne change pas." : "You can also decide at check-in — booking stays one click.")}
          </p>
        </div>
        {open ? <ChevronUp className="w-4 h-4 text-emerald-200 shrink-0" /> : <ChevronDown className="w-4 h-4 text-emerald-200 shrink-0" />}
      </button>
      {open && (
        <div className="mt-3 space-y-3">
          <div>
            <p className="text-[10px] uppercase tracking-wider text-zinc-400 mb-1.5">{isFr ? "Combos populaires · 1 tape" : "Popular combos · one tap"}</p>
            <div className="flex flex-wrap gap-1.5">
              {ANY3_COMBOS.map((c) => (
                <button key={c.join()} type="button" onClick={() => onChange(sameCombo(c) ? [] : c)}
                  className={`rounded-full px-3 py-1.5 text-xs font-semibold border transition ${sameCombo(c) ? "bg-emerald-400 text-black border-emerald-400" : "border-zinc-600 text-zinc-100 hover:border-emerald-300"}`}
                  data-testid={`any3-combo-${c.join("-").toLowerCase().replace(/\s+/g, "-")}`}>
                  {c.map(label).join(" + ")}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-wider text-zinc-400 mb-1.5">{isFr ? `Ou choisissez 3 zones (${value.length}/3)` : `Or pick any 3 (${value.length}/3)`}</p>
            <div className="flex flex-wrap gap-1.5">
              {ANY3_AREAS.map((a) => {
                const on = value.includes(a);
                const full = !on && value.length >= 3;
                return (
                  <button key={a} type="button" onClick={() => toggle(a)} disabled={full}
                    className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-semibold border transition disabled:opacity-40 ${on ? "bg-emerald-400 text-black border-emerald-400" : "border-zinc-600 text-zinc-100 hover:border-emerald-300"}`}
                    data-testid={`any3-area-${a.toLowerCase().replace(/\s+/g, "-")}`}>
                    {on && <Check className="w-3 h-3" />}{label(a)}
                  </button>
                );
              })}
            </div>
          </div>
          {value.length > 0 && (
            <button type="button" onClick={() => onChange([])} className="text-[11px] text-zinc-400 underline" data-testid="any3-areas-clear">
              {isFr ? "Effacer" : "Clear"}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
